import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';
import { PageTitle } from '../CoachDashboard/styles';
import TrainingPlanner from '../TrainingPlanner/TrainingPlanner';

const Container = styled.div`
  width: 100%;
`;

const JumperTrainingPlanner: React.FC = () => {
  const { user } = useAuth();

  if (!user?.athleteId) {
    return (
      <Container>
        <PageTitle>Training Planner</PageTitle>
        <p style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-gray)' }}>
          Please link your athlete ID in your account settings to view the training planner.
        </p>
      </Container>
    );
  }

  // Training Planner is view-only for jumpers (no add/edit capabilities)
  // Note: The component will show all sessions, but we can filter later if needed
  return (
    <Container>
      <TrainingPlanner readOnly={true} />
    </Container>
  );
};

export default JumperTrainingPlanner;

